import React from 'react';
import { BsImage } from '@react-icons/all-files/bs/BsImage';

import { decorateComponent } from '../../documentComponents';
import { Image } from './Image';
import { ImageInspector } from './Image.Inspector';

export default decorateComponent(Image, 'block', {
  id: 'image',
  label: '이미지',
  allowedChildren: ['imageMapLink', 'imageMapShare', 'imageMapBraze'],
  renderIcon: () => <BsImage />,
  renderInspector: ImageInspector,
});
